export const StorageHelper = {
  setSession: (key: string, value: any) => {
    try {
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.warn("Failed to save to session storage:", error);
    }
  },

  getSession: (key: string, defaultValue: any = null) => {
    try {
      const item = sessionStorage.getItem(key);
      return item !== null ? JSON.parse(item) : defaultValue;
    } catch (error) {
      console.warn("Failed to read from session storage:", error);
      return defaultValue;
    }
  },

  setLocal: (key: string, value: any) => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.warn("Failed to save to local storage:", error);
    }
  },

  getLocal: (key: string, defaultValue: any = null) => {
    try {
      const item = localStorage.getItem(key);
      return item !== null ? JSON.parse(item) : defaultValue;
    } catch (error) {
      console.warn("Failed to read from local storage:", error);
      return defaultValue;
    }
  },

  getWithFallback: (
    key: string,
    defaultValue: any = null,
    preferSession = true
  ) => {
    try {
      if (preferSession) {
        const sessionValue = sessionStorage.getItem(key);
        if (sessionValue !== null) return JSON.parse(sessionValue);

        const localValue = localStorage.getItem(key);
        return localValue !== null ? JSON.parse(localValue) : defaultValue;
      }

      const localValue = localStorage.getItem(key);
      if (localValue !== null) return JSON.parse(localValue);

      const sessionValue = sessionStorage.getItem(key);
      return sessionValue !== null ? JSON.parse(sessionValue) : defaultValue;
    } catch (error) {
      console.warn(`Failed to read ${key} from storage:`, error);
      return defaultValue;
    }
  },

   setBoth: (key: string, value: any) => {
    try {
      if (value === null || value === undefined) {
        sessionStorage.removeItem(key);
        localStorage.removeItem(key);
        return;
      }

      const stringValue = JSON.stringify(value);
      sessionStorage.setItem(key, stringValue);
      localStorage.setItem(key, stringValue);
    } catch (error) {
      console.warn("Failed to save to both storage types:", error);
    }
  },
};